import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import logo from "../../../assets/logo_report.png";

export const useExportPDFCanvas = () => {
	const exportPDF = async (element: HTMLElement, fileName = "documento.pdf", loadComp?: { start: () => void; stop: () => void }) => {
		if (!element) return;

		try {
			loadComp?.start?.();

			// Clona o conteúdo
			const cloned = element.cloneNode(true) as HTMLElement;
			cloned.style.width = "800px";
			cloned.style.padding = "32px";
			cloned.style.margin = "0 auto";
			cloned.style.backgroundColor = "#fff";

			const wrapper = document.createElement("div");
			wrapper.style.position = "absolute";
			wrapper.style.left = "-9999px";
			document.body.appendChild(wrapper);
			wrapper.appendChild(cloned);

			const canvas = await html2canvas(cloned, { scale: 2 });
			const imgData = canvas.toDataURL("image/png");

			const pdf = new jsPDF("p", "mm", "a4");
			const pageWidth = pdf.internal.pageSize.getWidth();
			const marginX = 15;
			let currentY = 10;

			// Logo
			const logoImage = new Image();
			logoImage.src = logo as string;
			await new Promise((resolve) => {
				logoImage.onload = () => resolve(true);
			});

			const logoWidth = 30;
			const logoHeight = (logoImage.height * logoWidth) / logoImage.width;

			// Logo à esquerda
			pdf.addImage(logoImage, "PNG", marginX, currentY, logoWidth, logoHeight);

			// Título centralizado
			const titleText = "Detalhamento de Taxa de Setup";
			pdf.setFont("helvetica", "bold");
			pdf.setFontSize(16);
			pdf.setTextColor("#5916b1");
			pdf.text(titleText, pageWidth / 2, currentY + logoHeight / 2 + 1.5, {
				align: "center",
			});

			currentY += logoHeight + 6;

			// Linha divisória
			pdf.setDrawColor(180);
			pdf.setLineWidth(0.1);
			pdf.line(marginX, currentY, pageWidth - marginX, currentY);
			currentY += 2;

			// Conteúdo
			const imgProps = pdf.getImageProperties(imgData);
			const contentWidth = pageWidth - marginX * 2;
			const contentHeight = (imgProps.height * contentWidth) / imgProps.width;

			pdf.addImage(imgData, "PNG", marginX, currentY, contentWidth, contentHeight);
			pdf.save(fileName);
		} catch (error) {
			console.error("Erro ao exportar PDF:", error);
		} finally {
			loadComp?.stop?.();
			const wrapper = document.querySelector("#pdf-wrapper");
			if (wrapper) wrapper.remove();
		}
	};

	return { exportPDF };
};
